export default __webpack_public_path__ + "static/media/todo_icon.bd41b06b.png";